import React from "react";
import {Badge} from "@/components/ui/badge";
import {AlertTriangle, CheckCircle2, Loader2, XCircle} from "lucide-react";
import type {Job} from "@/model/Job";

interface JobStatusBadgeProps {
    job: Job
}

const JobStatusBadge: React.FC<JobStatusBadgeProps> = ({job}) => {
    if (job.status === "running") {
        return (
            <Badge
                variant="outline"
                className="shrink-0 gap-1 border-blue-200 bg-blue-50 text-blue-700 font-medium dark:border-blue-800 dark:bg-blue-950 dark:text-blue-300"
            >
                <Loader2 className="h-3.5 w-3.5 animate-spin"/>
                Running
            </Badge>
        );
    }

    if (job.status === "done") {
        return (
            <Badge
                variant="outline"
                className="shrink-0 gap-1 border-emerald-200 bg-emerald-50 text-emerald-700 font-medium dark:border-emerald-800 dark:bg-emerald-950 dark:text-emerald-300"
            >
                <CheckCircle2 className="h-3 w-3"/>
                Done
            </Badge>
        );
    }

    if (job.status === "failed") {
        return (
            <Badge
                variant="outline"
                className="shrink-0 gap-1 bg-red-100 text-red-700 border border-red-200 font-medium dark:bg-red-950 dark:text-red-300 dark:border-red-800"
            >
                <XCircle className="h-3 w-3"/>
                Failed
            </Badge>
        );
    }

    return (
        <Badge variant="secondary" className="shrink-0 gap-1 border border-amber-200 bg-amber-50 text-amber-700 font-medium dark:border-amber-900 dark:bg-amber-950/40 dark:text-amber-300">
            <AlertTriangle className="h-3 w-3"/>
            {job.status ?? "Unknown"}
        </Badge>
    );
};

export default JobStatusBadge
